import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleError, handleResponse } from "../utils/handleResponses";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import EndpointFunctions from "../utils/Functions/endpointFunctions";
import { message } from "antd";
import Endpoints from "../api/endpoints";
import useAuth from "../hooks/useAuth";

const useFirmFileService = () => {
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();
  const { firmAuth, setFirmAuth } = useAuth();

  const useGetPersonnelFirm = (requestBody) => {
    return useQuery({
      queryKey: ["FirmFilePersonnels"],
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getFilePersonnelsFirm,
          axiosPrivate: axiosPrivate,
          httpParams: requestBody,
        });
        return handleResponse({ response });
      },
    });
  };

  const useGetAllFilesFirm = () => {
    return useQuery({
      queryKey: ["FirmFiles"],
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getAllFilesFirm,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
    });
  };

  const useGetAllFilesByPersonnelIdFirm = (requestBody) => {
    return useQuery({
      queryKey: ["FirmFiles", requestBody],
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getAllFilesByPersonnelId,
          axiosPrivate: axiosPrivate,
          httpParams: requestBody,
        });
        return handleResponse({ response });
      },
    });
  };

  const useAddFileFirm = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.addFileFirm,
          axiosPrivate: axiosPrivate,
          formData: requestBody,
          isMultiPart: true,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Belge Başarıyla Eklendi");
        // Invalidate the advert query to refresh the data
        queryClient.invalidateQueries({ queryKey: ["FirmFiles"] });
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeleteFileFirm = () => {
    return useMutation({
      mutationFn: async (id) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deleteFileFirm,
          axiosPrivate: axiosPrivate,
          recordId: id,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Belge Başarıyla Silindi");
        // Invalidate the advert query to refresh the data
        queryClient.invalidateQueries({ queryKey: ["FirmFiles"] });
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useAddFirmDocuments = () => {
    return useMutation({
      mutationFn: async ({ formData, endpointUrl }) => {
        const response = await EndpointFunctions.postData({
          endpointURL: endpointUrl,
          axiosPrivate: axiosPrivate,
          formData: formData,
          isMultiPart: true,
        });
        return handleResponse({ response });
      },
      onSuccess: (data) => {
        message.success("Belge Başarıyla Eklendi");
        // Invalidate the advert query to refresh the data
        queryClient.setQueryData(["firm"], data);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  return {
    useGetPersonnelFirm,
    useAddFileFirm,
    useDeleteFileFirm,
    useGetAllFilesFirm,
    useGetAllFilesByPersonnelIdFirm,
    useAddFirmDocuments,
  };
};

export default useFirmFileService;
